import React, { useContext } from "react";
import { Box } from "@mui/material";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-date-fns';
import { darkerGrey, green } from "../../shared/colours";
import companyEmployeeService from "../../services/companyEmployeeService";
import { format } from "date-fns";
import { ThemeModeContext } from "../../shared/Theme";
import Chart from 'chart.js/auto';

const RiskOverTimeGraph = (props) => {

	const themeModeContext = useContext(ThemeModeContext);
	
	const options = {
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			x: {
				ticks: {
					autoSkip: true,
					maxTicksLimit: 11,
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					}
				}
			},
			y: {
				ticks: {
					beginAtZero: true,
					color: themeModeContext.themeMode === "light"? darkerGrey : green,
					font: {
						size: 10
					}
				}
			}
		},
		maintainAspectRatio: false,
		pointRadius: 0
	};
	
	const getData = () => {
		const riskHistory = (companyEmployeeService.riskHistory && companyEmployeeService.riskHistory.length >= 3)?
			companyEmployeeService.riskHistory[3] : null;
		
		const labels = [];
		const riskData = [];
		
		if (riskHistory && riskHistory.data && riskHistory.data.length > 0) {
			for (let i in riskHistory.data) {
				const scoreDate = new Date(riskHistory.data[i].date);
				labels.push(format(scoreDate, "MMM yy"));
				riskData.push(riskHistory.data[i].uLearnRiskScore);
			}
		}
		
		const data = {
			labels: labels,
			datasets: [{
				label: "Risk",
				data: riskData,
				backgroundColor: "rgba(0, 0, 0, 0)",
				borderColor: "#ff03ed",
				fill: true
			}]
		};
		
		return data;
	};
	
	return (
		<Box sx={{ width: "100%", paddingBottom: "1em" }}>
			<Box sx={{
				flexGrow: 1,
				border: "2px",
				width: "90%",
				height: "9em",
				margin: "2em auto"
			}}>
				<Line data={getData()} options={options} height="10em"/>
				{/* <Line data={getData} options={options} width="100%"/> */}
			</Box>
		</Box>
	);

}

export default RiskOverTimeGraph;